import type { JSX } from 'react';
import { Alert, FormSection, Radio } from '@ksyos/design-system';
import type { BariPreCaroInactivityPoliReportData } from '@common/validation/customControls/bariPre/bariPreCaroInactivityPoliReport/v1/bariPreCaroInactivityPoliReportSchemaV1';
import { Vervolgstap } from '@common/customControls/bariatrics';
import { bariPreCaroInactivityPoliReportVervolgstappen } from '@common/validation/customControls/bariPre/bariPreCaroInactivityPoliReport/v1/bariPreCaroInactivityPoliReportSchemaV1';
import {
    RadioGroupFormGroup,
    TextAreaFormGroup,
} from '@frontend/components/pages/episodeCategory/customControls/processActivityFormGroupFields';
import { useProcessActivityEditContext } from '@frontend/utils';
import { BariPreCaroAccountNotActivated } from './BariPreCaroAccountNotActivated';

export function BariPreCaroInactivityPoliReportEdit(): JSX.Element {
    const { data, processActivityId } = useProcessActivityEditContext<BariPreCaroInactivityPoliReportData>();

    return (
        <>
            <FormSection>
                <BariPreCaroAccountNotActivated untilProcessActivityId={processActivityId ?? undefined} />
                <TextAreaFormGroup
                    fieldKey="verslag"
                    isRequired={true}
                    label="Verslag"
                />
                <RadioGroupFormGroup
                    fieldKey="vervolgstap"
                    isRequired={true}
                    label="Vervolgstap"
                >
                    {bariPreCaroInactivityPoliReportVervolgstappen.map((value) => (
                        <Radio
                            key={value}
                            label={value}
                            value={value}
                        />
                    ))}
                </RadioGroupFormGroup>
            </FormSection>
            {data.vervolgstap === Vervolgstap.activatielink_opnieuw_versturen && (
                <Alert
                    appearance="info"
                    hasIcon={true}
                >
                    Vergeet niet de activatielink opnieuw te versturen in het beheer van de Ksyos Bariatrie App
                </Alert>
            )}
        </>
    );
}
